
<template>
    <div class="main" v-if="isShow">
        <div class="model_content net">
            <div class="title">
                <span class="network">查看活畜档案</span>
                <!-- <img @click="hideModel" src="../../assets/close_icon.png" alt="" /> -->
                <i @click="hideModel" width="0.25rem" height="0.25rem" style="cursor: pointer;color:#FFFFFF;font-size: 0.23rem;"
                    class="el-icon-close"></i>
            </div>
            <!-- <div style="width:14.5rem;height: 0.005rem;border: 0.005rem dashed #AFDFFD;margin-top:19px;font-weight:normal;"></div> -->
            <div class="tabs_box">
                <el-tabs type="card">
                    <el-tab-pane>
                        <span @click="regulatory('基础信息')" :class="{active: regulatoryStatus === '基础信息'}" class="tabs_1"
                            slot="label" ref="title">基础信息</span>
                        <div class="info">
                            <div>
                                <img src="@/assets/login_bg.png" alt="">
                            </div>
                            <div class="info_1">
                                <span>耳标编号：{{baseInfo.theEarEncipher}}</span>
                                <span>活畜类别：{{baseInfo.typeName}}</span>
                                <span>出生日期：{{baseInfo.birth}}</span>
                                <span>活畜月龄：{{baseInfo.monthAge}}</span>
                                <span>活畜状态：<i
                                        style="font-style: normal;color: #2A75FD;">{{baseInfo.liveStatus}}</i></span>
                                <span>监管状态：{{baseInfo.superviseStatus}}</span>
                            </div>
                            <div>
                                <span>父亲编号：{{baseInfo.fatherNumber}}</span>
                                <span>父亲编号类型：{{baseInfo.fatherNumberType}}</span>
                                <span>母亲编号：{{baseInfo.motherNumber}}</span>
                                <span>母亲编号类型：{{baseInfo.motherNumberType}}</span>
                                <span>出栏去向：{{baseInfo.marketWhere}}</span>
                                <span>出栏日期：{{baseInfo.cropDate}}</span>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span @click="regulatory('免疫/检疫记录')" :class="{active: regulatoryStatus === '免疫/检疫记录'}"
                            class="tabs_1" slot="label" ref="title">免疫/检疫记录</span>
                        <el-table v-if="show" height="480" :data="tableData" style="width: 100%">
                            <el-table-column prop="immuneDate" label="检疫/免疫日期">
                            </el-table-column>
                            <el-table-column prop="immuneProject" label="免疫/检疫项目">
                            </el-table-column>
                            <el-table-column prop="projectName" label="项目名称">
                            </el-table-column>
                            <el-table-column prop="dosage" label="剂量">
                            </el-table-column>
                            <el-table-column prop="immuneManner" label="检疫/免疫方式">
                            </el-table-column>
                            <el-table-column prop="immuneResult" label="检疫/免疫结果">
                            </el-table-column>
                            <el-table-column prop="immuneOrganization" label="检疫/免疫机构">
                            </el-table-column>
                            <el-table-column prop="operator" label="操作人员">
                            </el-table-column>
                            <el-table-column prop="remark" label="备注说明">
                            </el-table-column>
                        </el-table>
                        <!-- <el-pagination small background layout="prev, pager, next" :total="50">
                        </el-pagination> -->
                    </el-tab-pane>
                    <el-tab-pane>
                        <span @click="regulatory('疫病/治病记录')" name="'疫病/治病记录'"
                            :class="{active: regulatoryStatus === '疫病/治病记录'}" class="tabs_1" slot="label"
                            ref="title">疫病/治病记录</span>
                        <el-table v-if="show_1" height="480" :data="tableData" style="width: 100%">
                            <el-table-column prop="cureDate" label="治病日期">
                            </el-table-column>
                            <el-table-column prop="cureType" label="疾病类型">
                            </el-table-column>
                            <el-table-column prop="symptom" label="症状及并发症">
                            </el-table-column>
                            <el-table-column prop="curePlan" label="治疗方案">
                            </el-table-column>
                            <el-table-column prop="veterinaryName" label="兽医姓名">
                            </el-table-column>
                            <el-table-column prop="cureResult" label="治疗结果">
                            </el-table-column>
                        </el-table>
                        <!-- <pagination :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
                            @pagination="getList" /> -->
                    </el-tab-pane>
                    <el-tab-pane>
                        <span @click="regulatory('体重记录')" :class="{active: regulatoryStatus === '体重记录'}" class="tabs_1"
                            slot="label" ref="title">体重记录</span>
                        <el-table v-if="show_2" height="480" :data="tableData" style="width: 100%">
                            <el-table-column prop="weighDate" label="称重日期">
                            </el-table-column>
                            <el-table-column prop="currentWeight" label="本次称重重量">
                            </el-table-column>
                            <el-table-column prop="lastWeight" label="上次称重重量">
                            </el-table-column>
                            <el-table-column prop="growingWeight" label="比上次增重">
                            </el-table-column>
                            <el-table-column prop="weighPeople" label="称重人员">
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span @click="regulatory('繁育记录')" :class="{active: regulatoryStatus === '繁育记录'}" class="tabs_1"
                            slot="label" ref="title">繁育记录</span>
                        <el-table v-if="show_3" height="480" :data="tableData" style="width: 100%">
                            <el-table-column prop="childbirthDate" label="分娩日期">
                            </el-table-column>
                            <el-table-column prop="mattingTimes" label="配种次数">
                            </el-table-column>
                            <el-table-column prop="mattingDate" label="配种日期">
                            </el-table-column>
                            <el-table-column prop="mattingPeople" label="配种员">
                            </el-table-column>
                            <el-table-column prop="breedingOxenNumber" label="种公牛号">
                            </el-table-column>
                            <el-table-column prop="pregnancyDays" label="妊娠天数">
                            </el-table-column>
                            <el-table-column prop="expectedDate" label="预产期">
                            </el-table-column>
                            <el-table-column prop="calvingDate" label="产犊日期">
                            </el-table-column>
                            <el-table-column prop="calfGender" label="犊牛性别">
                            </el-table-column>
                            <el-table-column prop="calfNumber" label="犊牛编号">
                            </el-table-column>
                            <el-table-column prop="abortionDate" label="流产日期">
                            </el-table-column>
                            <el-table-column prop="remark" label="备注说明">
                            </el-table-column>
                        </el-table>
                        <!-- <el-pagination small background layout="prev, pager, next" :total="50">
                        </el-pagination> -->
                    </el-tab-pane>
                </el-tabs>
                <div class="page"
                    v-if="regulatoryStatus==='免疫/检疫记录'||regulatoryStatus==='疫病/治病记录'||regulatoryStatus==='体重记录'||regulatoryStatus==='繁育记录'">
                    <el-pagination small @current-change="change" :current-page.sync="queryParams.pageNum"
                        :page-size.sync="queryParams.pageSize" background layout="prev, pager, next" :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
// import Pagination from "@/components/pagination";
export default {
    data: () => {
        return {
            show: false,
            show_1: false,
            show_2: false,
            show_3: false,
            isShow: false,
            regulatoryStatus: '基础信息',
            userInfo: {},
            // bankNumber: "",
            // 存储基础信息
            baseInfo: {
                "theEarsNum": "XMB023641", // 耳际编号
                "animalType": "西门塔尔-二代-基础母牛", // 活畜类别
                "birth": "2022-10-01", // 出生日期
                "monthAge": "5月", // 活畜月龄
                "animalStatus": "养殖中", // 活畜状态
                "superviseStatus": "未监管", // 监管状态
                "parentNumber": "15489620", // 父亲编号
                "parentNumberType": "耳际", // 父亲编号类型
                "motherNumber": "02365410", // 母亲编号
                "motherNumberType": "电子项圈", // 母亲编号类型
                "slaughterDisPosition": "售出", // 出栏去向
                "cropDirection": "2022-10-10" // 出栏日期
            },
            tableData: [],
            // 存储免疫记录数据
            immuneRecordData: [],
            // 存储治病记录数据
            diseaseRecordData: [],
            // 存储体重记录数据
            weightRecordData: [],
            // 存储繁育记录数据
            breedRecordData: [],
            queryParams: {
                pageNum: 1,
                pageSize: 10,
            },
            // 总条数
            total: 0,
        };
    },
    components: {
    },
    // props: {
    //     animalRecord: {
    //         type: Object
    //     },
    // },
    watch: {},
    mounted() {
    },
    created() {
        this.getList()
    },
    filters: {
    },
    methods: {
        // 获取养殖信息
        breedList() {
            this.$http({
                url: 'screenapp-service/screenLiveStock/records',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    animalId: this.baseInfo.animalId
                },
            }).then(res => {
                // console.log(res, 'res');
                const data = res.data;
                if (data.code === 200) {
                    this.immuneRecordData = data.result.immuneRecords
                    this.diseaseRecordData = data.result.cureRecords
                    this.weightRecordData = data.result.weighRecords
                    this.breedRecordData = data.result.breedRecords
                } else {
                    // this.$message.error(data.message);
                }
            })
        },
        getList() {
            if (this.regulatoryStatus === '免疫/检疫记录') {
                this.getData(this.immuneRecordData)
                // this.tableData = this.immuneRecordData
                this.show = true
                this.show_1 = false
                this.show_2 = false
                this.show_3 = false
            }
            if (this.regulatoryStatus === '疫病/治病记录') {
                this.getData(this.diseaseRecordData)
                // this.tableData = this.diseaseRecordData
                this.show_1 = true
                this.show = false
                this.show_2 = false
                this.show_3 = false
            }

            if (this.regulatoryStatus === '体重记录') {
                this.getData(this.weightRecordData)
                // this.tableData = this.weightRecordData
                this.show_2 = true
                this.show_1 = false
                this.show = false
                this.show_3 = false
            }
            if (this.regulatoryStatus === '繁育记录') {
                this.getData(this.breedRecordData)
                // this.tableData = this.breedRecordData
                this.show_3 = true
                this.show_2 = false
                this.show_1 = false
                this.show = false
            }
        },
        getData(data) {
            this.total = data.length
            this.tableData = data.filter((item, index) => {
                return (
                    index < this.queryParams.pageNum * this.queryParams.pageSize &&
                    index >= this.queryParams.pageSize * (this.queryParams.pageNum - 1)
                )
            })
        },
        // 分页
        change(newPage) {
            this.queryParams.pageNum = newPage
            this.getList()
        },
        showModel(animalRecord) {
            this.isShow = true;
            this.baseInfo = animalRecord
            // 获取养殖信息
            this.breedList()
            // this.breedRecordData = animalRecord.breedRecord.data
            // this.diseaseRecordData = animalRecord.diseaseRecord.data
            // this.immuneRecordData = animalRecord.immuneRecord.value
            // this.weightRecordData = animalRecord.weightRecord.data
        },
        hideModel() {
            this.isShow = false;
        },
        // 体重切换栏等切换
        regulatory(status) {
            if (status === '基础信息') {
                this.regulatoryStatus = status
            }
            if (status === '免疫/检疫记录') {
                this.regulatoryStatus = status
                this.getList()
            }
            if (status === '疫病/治病记录') {
                this.regulatoryStatus = status
                this.getList()
            }
            if (status === '体重记录') {
                this.regulatoryStatus = status
                this.getList()

            }
            if (status === '繁育记录') {
                this.regulatoryStatus = status
                this.getList()
            }
        },
        goDetail(item) {
            this.$router.push({
                name: "subBank",
                query: {
                    id: item.id,
                },
            });
        },
    },
};
</script>

<style lang="scss">
.net {
    /* .el-table {
        margin-left: 20px;
    } */
    
        .el-table__fixed-right::before,
        .el-table__fixed::before {
            height: 0px;
            /* background: #409EFF; */
        }
    
        /* .el-table__fixed {
        width: 0;
        height: 0;
    } */
        /* .el-table::before {
        left: 0;
        bottom: 0;
        width: 100%;
        height: 12px;
         background: #409EFF;
    } */
        .el-tabs__content {
            /* background-color: red; */
            height: 8rem;
        }
    
        .el-table td.el-table__cell,
        .el-table th.el-table__cell.is-leaf {
            border: none;
        }
    
        /*最外层透明*/
        .el-table,
        .el-table__expanded-cell {
            background-color: transparent;
        }
    
        /* 表格内背景颜色 */
        .el-table tr {
            background-color: transparent;
            height: 15px;
        }
    
        .el-table th {
            font-size: 0.18rem;
            font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
            font-weight: 200;
            color: #FFFFFF;
            /* background-color: transparent !important; */
            /* 背景透明 */
            background: rgba(12, 43, 95, 0.749) !important;
            border: 0;
            height: 0.26rem;
            line-height: 0.26rem;
        }
    
        .el-table tr,
        .el-table td {
            color: #f6f6f7;
            font-size: 12px;
            font-weight: 200;
            background-color: transparent !important;
            /* 背景透明 */
            border: 0;
            height: 15px;
            line-height: 15px;
        }
    
        .el-table tr:nth-child(2n) {
            background: #22385d !important;
        }
    
        .el-table th.el-table__cell>.cell {
            font-size: 12px;
        }
    
        .el-table__body tr.current-row>td.el-table__cell,
        .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
            background: rgba(255, 255, 255, 0.1) !important;
            color: #FFFFFF;
        }
    
        .el-table::before {
            left: 0;
            bottom: 0;
            width: 100%;
            height: 0px;
        }
    
        .el-pagination.is-background.el-pagination--small .btn-prev {
            background-color: transparent !important;
            color: #FFFFFF;
        }
    
        .el-pagination.is-background.el-pagination--small .btn-next {
            background-color: transparent !important;
            color: #FFFFFF;
        }
    
        .el-pagination.is-background .el-pager li {
            background-color: transparent !important;
            color: #FFFFFF;
        }
    
        .el-pagination {
            font-weight: 400;
        }
    
        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #409EFF !important;
        }
    
        .el-pagination.is-background .btn-prev:disabled {
            color: #c0c4c0;
        }
    
        .el-pagination.is-background .btn-next:disabled {
            color: #c0c4c0;
        }
}
</style>
<style lang="scss" scoped>
// /*解决固定列遮盖底部滚定条导致滚动条无法滚动的问题*/
// ::v-deep .el-table__body-wrapper {
//     z-index: 2
// }

// ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
//     height: 10px;
// }

// // ::v-deep .el-scrollbar__wrap {
// //     width: 20px !important;
// //     background-color: red !important;
// //     height: 20px !important;
// //     color: yellow !important;
// //     overflow-x: scroll !important;
// // }
// /* 滚动槽 */
// ::v-deep ::-webkit-scrollbar-track {
//     // -webkit-box-shadow: red;
//     background: rgba(28, 71, 163, 0.2);
//     border-radius: 0,
// }
// /* 滚动条滑块 */
// ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
//     background: #2C76FE;
//     border-radius: 0;
// }
// ::v-deep ::-webkit-scrollbar-button {
//     background: #18418e;
// }
.main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.85);

    .model_content {
        position: relative;
        width: 15.25rem;
        height: 9.75rem;
        background: rgba(12, 43, 95, 0.749);
        // box-shadow: 0rem 0.03rem 0.28rem 0rem rgba(47, 244, 225, 0.5),
        //     inset 0rem 0.01rem 0.06rem 0rem #08dac8;
        // border: 0.03rem solid #01faff;
        border: 0.01rem solid rgba(41, 116, 253, 0.47);
        padding: 0.3rem;
        z-index: 999;

        .tabs_box {
            //   padding: 0 1.85rem;
            // position: absolute;
            // left: 50%;
            // transform: translate(-50%, 0);
            margin-right: 0.2rem;
            margin-left: -0.1rem;
            margin-top: 0.3rem;

            .info {
                display: flex;
                width: 10rem;
                height: 6.25rem;
                background: rgba(83, 83, 145, 0.28);
                opacity: 1;
                border: 0.01rem solid #2A75FD;
                margin: 0.8rem auto;

                div {
                    margin: 0 0.5rem;
                    margin-top: 0.625rem;
                    width: 32%;
                    display: flex;
                    flex-direction: column;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;

                    img {
                        width: 1.96rem;
                        height: 2.36rem;
                        border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
                    }

                    span {
                        margin-top: 45px;
                        display: block;
                        // width: 2.26rem;
                        height: 0.18rem;
                        // font-size: 0.2rem;
                        // font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        // font-weight: 400;
                        // color: #FFFFFF;
                        line-height: 0.18rem;
                        -webkit-background-clip: text;
                    }

                    span:nth-child(1) {
                        margin-top: 0;
                    }
                }

                .info_1 {
                    width: 43%;
                    margin: 0;
                    margin-top: 0.625rem;
                }
            }

            .active {
                background: #286AE7;
            }

            .el-tabs {
                ::v-deep .el-tabs__header {
                    border: none;

                    ::v-deep .is-active {
                        border: none;
                    }
                }

                ::v-deep .el-tabs__item {
                    width: 1.5rem;
                    line-height: 0.38rem;
                    height: 0.38rem;
                    background-color: #0f316e;
                    color: #FFFFFF;
                    text-align: center;
                    font-size: 0.18rem;
                    // font-size: 20px !important;
                    font-family: MicrosoftYaHei;
                    box-shadow: 0px 2px 0px 0px rgba(47, 244, 225, 0.5);
                    border: none;
                    margin-left: 0.37rem;

                    .tabs_1 {
                        display: block;
                        width: 1.5rem;
                        line-height: 0.38rem;
                        margin-left: -20px;
                    }
                }

                ::v-deep .el-tabs__nav {
                    border: none;
                }
            }
        }

    }

    .page {
        // background-color: red;
        // margin-left: 80%;
        // margin-top: 20%;
        position: absolute;
        top: 92%;
        right: 2%;
    }
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .network {
        font-size: 0.23rem;
        color: #FFFFFF;
    }

    // .network_number {
    //     font-size: 0.25rem;
    //     font-family: Helvetica_1;
    //     font-weight: normal;
    //     color: #ffffff;
    //     letter-spacing: 1px;
    //     line-height: 0.25rem;
    // }

    // img {
    //     width: 0.28rem;
    //     height: 0.28rem;
    // }
}

// .c_D75304 {
//     color: #d75304;
// }


// .cup {
//     cursor: pointer;
// }
</style>